import gql from 'graphql-tag';

export const VO_CONTACTS = gql`
  query VoContacts($VOId: ID!) {
    creditApplication(VOId: $VOId) {
      id
      creditApplicationOwner {
        ownerPgId
        firstName
        lastName
        title
        phone
        mobilePhone
        pc
      }
      creditApplicationContacts {
        ownerPgId
        firstName
        lastName
        title
        phone
        mobilePhone
        pc
      }
    }
  }
`;
